/**
 * epgTimelineContainer.tsx
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const EpgTimelineContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  max-width: ${1820 * Screen.widthRatio}px;
  margin-bottom: ${12 * Screen.widthRatio}px;
  margin-top: ${4 * Screen.widthRatio}px;
`;

export default EpgTimelineContainer;
